import { createSlice } from '@reduxjs/toolkit'
const initialState = {
  balances:{
    antCoinBalance: undefined,
    antFoodBalance: undefined,
    chestCommonBalance: undefined,
    chestUnCommonBalance: undefined,
    chestRareBalance: undefined,
    chestUltraRareBalance: undefined,
    chestLegendaryBalance: undefined,
    levelingPotionBalance: undefined,
  },
  nft: {
    nfts: [],
    error: undefined,
    loading: false,
  },
  stakedNft: {
    nfts: [],
    error: undefined,
    loading: false,
  },
  bossedNft: {
    nfts: [],
    error: undefined,
    loading: false,
  },
  taskedNft: {
    nfts: [],
    error: undefined,
    loading: false,
  },
  leveledNft: {
    nfts: [],
    error: undefined,
    loading: false,
  }
}
export const appSlice = createSlice({
  name: 'appStore',
  initialState,
  reducers: {
    setAntCoinBalanceStore: (state, { payload }) => {
      state.balances.antCoinBalance = payload
    },
    setAntFoodBalanceStore: (state, { payload }) => {
      state.balances.antFoodBalance = payload
    },
    setChestCommonBalanceStore: (state, { payload }) => {
      state.balances.chestCommonBalance = payload
    },
    setChestUnCommonBalanceStore: (state, { payload }) => {
      state.balances.chestUnCommonBalance = payload
    },
    setChestRareBalanceStore: (state, { payload }) => {
      state.balances.chestRareBalance = payload
    },
    setChestUltraRareBalanceStore: (state, { payload }) => {
      state.balances.chestUltraRareBalance = payload
    },
    setChestLegendaryBalanceStore: (state, { payload }) => {
      state.balances.chestLegendaryBalance = payload
    },
    setLevelingPotionBalanceStore: (state, { payload }) => {
      state.balances.levelingPotionBalance = payload
    },
    setNftsStore: (state, { payload }) => {
      state.nft.nfts = payload
    },
    setNftLoading: (state, { payload }) => {
      state.nft.loading = payload
    },
    setNftError: (state, { payload }) => {
      state.nft.error = payload
    },
    setStakedNftsStore: (state, { payload }) => {
      state.stakedNft.nfts = payload
    },
    setStakedNftLoading: (state, { payload }) => {
      state.stakedNft.loading = payload
    },
    setStakedNftError: (state, { payload }) => {
      state.stakedNft.error = payload
    },
    setBossedNftsStore: (state, { payload }) => {
      state.bossedNft.nfts = payload
    },
    setBossedNftLoading: (state, { payload }) => {
      state.bossedNft.loading = payload
    },
    setBossedNftError: (state, { payload }) => {
      state.bossedNft.error = payload
    },
    setTaskedNftsStore: (state, { payload }) => {
      state.taskedNft.nfts = payload
    },
    setTaskedNftLoading: (state, { payload }) => {
      state.taskedNft.loading = payload
    },
    setTaskedNftError: (state, { payload }) => {
      state.taskedNft.error = payload
    },
    setLeveledNftsStore: (state, { payload }) => {
      state.leveledNft.nfts = payload
    },
    setLeveledNftLoading: (state, { payload }) => {
      state.leveledNft.loading = payload
    },
    setLeveledNftError: (state, { payload }) => {
      state.leveledNft.error = payload
    }
  },
})

// Action creators are generated for each case reducer function
export const { setAntCoinBalanceStore, setAntFoodBalanceStore, setChestCommonBalanceStore, setChestUnCommonBalanceStore, setChestRareBalanceStore, setChestUltraRareBalanceStore, setChestLegendaryBalanceStore, setLevelingPotionBalanceStore, setNftsStore, setNftLoading, setNftError, setStakedNftsStore, setStakedNftLoading, setStakedNftError,setBossedNftsStore, setBossedNftLoading, setBossedNftError, setLeveledNftsStore,setTaskedNftsStore, setTaskedNftLoading, setTaskedNftError, setLeveledNftLoading, setLeveledNftError} = appSlice.actions

export const selectAppBalances = (state) => state.appStore.balances
export const selectAppNft = (state) => state.appStore.nft
export const selectAppStakedNft = (state) => state.appStore.stakedNft
export const selectAppBossedNft = (state) => state.appStore.bossedNft
export const selectAppTaskedNft = (state) => state.appStore.taskedNft
export const selectAppLeveledNft = (state) => state.appStore.leveledNft

export default appSlice.reducer